import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListCategories from '../../components/categories/list-categories.component';
import PAGE_TITLE_LIST from '../../config/page-title.config';

const ContentCategoriesView = () => {
  const pageTitle = `${PAGE_TITLE_LIST.CONTENT_CATEGORIES}`;

  return (
    <AppLayout pageTitle={pageTitle}>
      <ListCategories/>
    </AppLayout>
  );
};

export default ContentCategoriesView;
